/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginCredentials } from '../../models/login-credentials';
import { Token } from '../../models/token';

export interface AdminLoginPost$Params {
      body: LoginCredentials
}

export function adminLoginPost(http: HttpClient, rootUrl: string, params: AdminLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Token>> {
  const rb = new RequestBuilder(rootUrl, adminLoginPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Token>;
    })
  );
}

adminLoginPost.PATH = '/admin/login';
